import React, { Suspense } from 'react';
import { useDynamicConfigs } from '../../../hooks/useDynamicConfigs';
const RecItems = React.lazy(async () => await import('./RecommendedItems.component').then(({ RecommendedItemsComponent }) => ({ default: RecommendedItemsComponent })));
export const RecommendedItems = () => {
    const { supplementaryData } = useDynamicConfigs();
    if (supplementaryData?.featuredProducts === undefined)
        return null;
    return (React.createElement(Suspense, null,
        React.createElement(RecItems, null)));
};
